import React, { useEffect } from 'react';
import CancelFeedback from '../cancel/CancelFeedback';
import QualCodeActions from 'actions/QualCodeActions';
import { useTeamModal } from '../../../hooks/subscriptions/useTeamModal';
import AccountPageConstants from 'constants/AccountPageConstants';
import CancelConstants from '../cancel/CancelConstants';

const HELP_CHOICES = [CancelConstants.TECHNICAL, CancelConstants.HELP];

/**
 * Second step in the pause/cancel flow - detailed feedback
 */
const BillingModalPauseFeedbackDetail = ({ choice, feedback, onFeedbackChange }) => {
  const { navigateToPage } = useTeamModal();
  
  // If no choice, redirect back to survey
  useEffect(() => {
    if (!choice) {
      navigateToPage(AccountPageConstants.PAUSE_FEEDBACK_SURVEY);
    }
  }, [choice, navigateToPage]);

  const handleNext = () => {
    // Send feedback to the server
    QualCodeActions.sendFeedback({
      message: feedback,
      choice: choice
    });

    // Navigate based on choice
    const needsHelp = HELP_CHOICES.includes(choice);
    if (needsHelp) {
      navigateToPage(AccountPageConstants.PAUSE_FEEDBACK_HELP);
    } else {
      navigateToPage(AccountPageConstants.PAUSE_FEEDBACK_CONFIRM);
    }
  };

  const handleCancel = () => {
    navigateToPage(AccountPageConstants.PLAN_AND_BILLING);
  };

  // Don't render until we have a choice
  if (!choice) {
    return null;
  }

  return (
    <CancelFeedback
      checked={choice}
      feedback={feedback}
      onFeedbackChange={(e) => onFeedbackChange(e.target.value)}
      onNext={handleNext}
      onCancel={handleCancel}
    />
  );
};

export default BillingModalPauseFeedbackDetail;